export const namespaced = true

export const state = {
    productDetail: {},
    allow_edit: false,
};
export const getters = {
    getFilters: (state) => {
        return state;
    },
};